import { Field, Form, Formik } from "formik"
import React, { useEffect, useState } from "react"
import Input from "../../Input"
import { IStepThree } from "./interface"
import { ButtonContainer, ColumnForTwoInputs, InputContainer, InputWithHintContainer, RowForButton, RowForInput, RowForTwoInput, TitleField } from "./style"
import hint from "../../../assets/icons/hint.svg"
import api from "../../../service/api"
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast"
import Button from "../../Button"
import MsgErrorInput from "../../MsgErrorInput"
import * as Yup from "yup";

const StepThree = (props: IStepThree) => {
  const [selectedBank, setSelectedBank] = useState("")
  const [bank, setBank] = useState<any>("")
  const [searchBank, setSearchBank] = useState<Array<any>>([])
  const [addMessageError, setAddMessageError] = useState(false);
    const [dataBanks, setDataBanks] = useState<Array<any>>([
        {
          value: "",
          label: ""
        }
      ]);

      useEffect(()=>{
        const getBanks = async () => {
          const {data} = await api.get("banks/list")
          
          setDataBanks(data)
        }
        
        getBanks();
      }, [])

      useEffect(() => {
        dataBanks.map((item) => {
          if(item.label === bank){
            setSelectedBank(item.value as string)
          }
        })
      },[bank])

    const formValidationWithYup = Yup.object().shape({
      routing_number: Yup.string().required("*Obrigatório"),
      routing_digit: Yup.number().required("*Obrigatório"),
      account_number: Yup.string().required("*Obrigatório"),
      holder_name: Yup.string().required("*Obrigatório"),
    })

    return (
        <Formik
            initialValues={{
                bank: "",
                routing_number: "",
                routing_digit: "",
                account_number: "",
                holder_name: "",
                document: "",
                ein: "",
            }}
            validationSchema={formValidationWithYup}
            onSubmit={ async (values) => {
                toastCreate("submit", "info" , 3000, "Processando...")
                
                if (props.data.clientType === 1) {
                    let document = values.ein.replaceAll(".", "").replace("/", "").replace("-", "");
                    
                    if(document.length === 0) {
                      document = props.data.doc.replaceAll(".", "").replace("/", "").replace("-", "")
                    }
                    
                    try {
                      await api.post("/adm/ownerbranch/bank/create", {
                        holder_name: values.holder_name,
                        bank_code: selectedBank,
                        routing_number: values.routing_number.toString(),
                        account_number: values.account_number.toString(),
                        taxpayer_id: null,
                        ein: document,
                        sellerOwnerPayId: props.data.sellerOwnerPayId
                      });
    
                      setAddMessageError(false);
                      props.setStep(3);
                      toastUpdate("submit", "success" , 3000, "Banco registrado")
                      localStorage.setItem("addEstablishment", JSON.stringify(
                        {
                            ...props.data,
                            step: 3,
                        }
                      ))
                    } catch (error) {
                      setAddMessageError(true);
                      toastUpdate("submit", "error" , 3000, "Falha ao registrar banco")
                    }
                  } else if (props.data.clientType === 0) {
                    let account = values.account_number.replaceAll(".", "").replace("/", "").replace("-", "")
                    let document = values.document.replaceAll(".", "").replace("/", "").replace("-", "");
                    
                    if(document.length === 0) {
                      document = props.data.doc.replaceAll(".", "").replace("/", "").replace("-", "")
                    }
                    
                    try {
                      await api.post("/adm/ownerbranch/bank/create", {
                        holder_name: values.holder_name,
                        bank_code: selectedBank,
                        routing_number: values.routing_number.toString(),
                        account_number: account,
                        taxpayer_id: document,
                        ein: null,
                        sellerOwnerPayId: props.data.sellerOwnerPayId
                      });
    
                      setAddMessageError(false);
                      props.setStep(3);
                      toastUpdate("submit", "success" , 3000, "Banco registrado")
                      localStorage.setItem("addEstablishment", JSON.stringify(
                        {
                            ...props.data,
                            step: 3,
                        }
                      ))
                    } catch (error) {
                      setAddMessageError(true);
                      toastUpdate("submit", "error" , 3000, "Falha ao registrar banco")
                    }
                  }
            }}
        >
            {({values, dirty, isValid, touched, errors}) => {
                values.routing_digit = selectedBank
                
                return (
                    <Form>
                        <TitleField>Dados da conta bancária</TitleField>
                        <RowForInput>
                        <InputContainer>
                            <Field
                                list="bank" 
                                name="bank"
                                placeholder="Insira um banco"
                                as={Input}
                                isSearchField={true}
                                searchResults={searchBank}
                                searchType="bank"
                                value={values.bank = bank}
                                setValue={setBank}
                                onChange={(e: any) => {
                                    let search = e.target.value.toUpperCase()
                                    let result = dataBanks.filter((item: any) => item.label.toUpperCase().includes(search)).slice(0,4)
                                    
                                    setSearchBank(result)
                                    setBank( e.target.value);
                                }}
                            />
                        </InputContainer>
                        <ColumnForTwoInputs>
                            <RowForTwoInput>
                            <InputContainer style={{width: "65%"}}>
                                <Field id="routing_number" name="routing_number" placeholder="Agência"
                                  type="number"
                                  style={{borderColor: `${touched.routing_number && errors.routing_number ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                  as={Input}
                                />
                                {touched.routing_number && errors.routing_number ? <MsgErrorInput style={{top: 30}}>{ errors.routing_number }</MsgErrorInput> : null }
                            </InputContainer>
                            <InputContainer style={{width: "30%"}}>
                                <Field id="routing_digit" name="routing_digit" value={selectedBank} placeholder="Dígito" 
                                  onKeyUp={(e: any) => {
                                    setSelectedBank(e.target.value)
                                  }}
                                  
                                  type="number"
                                  style={{borderColor: `${touched.routing_digit && errors.routing_digit ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                  as={Input}
                                />
                                {touched.routing_digit && errors.routing_digit ? <MsgErrorInput style={{top: 30}}>{ errors.routing_digit }</MsgErrorInput> : null }
                            </InputContainer>
                            </RowForTwoInput>
                        </ColumnForTwoInputs>
                        </RowForInput>

                        <RowForInput>
                        <InputContainer>
                            <Field id="account_number" name="account_number" placeholder="Conta" 
                              type="text"
                              style={{borderColor: `${touched.account_number && errors.account_number ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                              as={Input}
                            />
                            {touched.account_number && errors.account_number ? <MsgErrorInput style={{top: 30}}>{ errors.account_number }</MsgErrorInput> : null }
                        </InputContainer>
                        <InputContainer>
                            <Field id="holder_name" name="holder_name" placeholder="Nome do Titular" 
                              style={{borderColor: `${touched.holder_name && errors.holder_name ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                              as={Input}
                            />
                            {touched.holder_name && errors.holder_name ? <MsgErrorInput style={{top: 30}}>{ errors.holder_name }</MsgErrorInput> : null }
                        </InputContainer>
                        </RowForInput>
                        
                        <RowForInput>
                        <InputContainer>
                            <InputWithHintContainer>
                              <Field value={values.document.length === 0 ? props.data.doc : values.document} disabled as={Input}/>
                              <img src={hint} alt="Dica" style={{marginLeft: 3}}/>
                            </InputWithHintContainer>
                        </InputContainer>
                        </RowForInput>
                        <RowForButton>
                          <ButtonContainer>
                            {
                                addMessageError
                                ? <MsgErrorInput>
                                    Erro ao adicionar estabelecimento
                                </MsgErrorInput>
                                : null
                            }
                            <Button
                              type="submit"
                              disabled={!(isValid && dirty)}
                            >
                              Avançar
                            </Button>
                          </ButtonContainer>
                        </RowForButton>
                    </Form>
                )
            }}
        </Formik>
    )
}

export default StepThree